// src/pages/Meijimura/SatisfactionSurvey.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomDropdown from '../../components/CustomDropdown';
import { saveSatisfactionSurvey } from '../../utils/firebase';
import '../../styles/SatisfactionSurvey.css';

// ★ 送信後の遷移先。実際のルーティングに合わせて変更してください
const NEXT_PATH = '/meijimura/couponreward';

export default function SatisfactionSurvey() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    easeOfUse: '',
    guideSatisfaction: ''
  });

  // ①使いやすさのオプション
  const easeOptions = [
    { value: 'veryEasy', label: t('veryEasy') },
    { value: 'easy', label: t('easy') },
    { value: 'neutral', label: t('neutral') },
    { value: 'difficult', label: t('difficult') },
    { value: 'veryDifficult', label: t('veryDifficult') }
  ];

  // ②ガイド内容の満足度のオプション
  const satisfactionOptions = [
    { value: 'verySatisfied', label: t('verySatisfied') },
    { value: 'satisfied', label: t('satisfied') },
    { value: 'neutral', label: t('neutral') },
    { value: 'dissatisfied', label: t('dissatisfied') },
    { value: 'veryDissatisfied', label: t('veryDissatisfied') }
  ];

  const handleEaseSelect = (option) => {
    setFormData(prev => ({ ...prev, easeOfUse: option.value }));
  };

  const handleSatisfactionSelect = (option) => {
    setFormData(prev => ({ ...prev, guideSatisfaction: option.value }));
  };

  const handleSubmit = async () => {
    if (!formData.easeOfUse || !formData.guideSatisfaction) {
      alert(t('please fill out all fields'));
      return;
    }

    try {
      await saveSatisfactionSurvey({
        easeOfUse: formData.easeOfUse,
        guideSatisfaction: formData.guideSatisfaction
      });

      navigate(NEXT_PATH, { state: formData });
    } catch (e) {
      console.error('Failed to save satisfaction survey', e);
      alert(t('failedToSaveProfile', 'データの保存に失敗しました'));
    }
  };

  return (
    <div className="satisfaction-survey">
      <div className="satisfaction-survey__inner">
        <div className="satisfaction-survey__logo-area">
          <img
            className="satisfaction-survey__logo"
            src="/images/logo_limot.png"
            alt="Limot logo"
          />
        </div>

        <p className="satisfaction-survey__description">
          {t('Thank you for using the guide.')}
          <br />
          {t('Please answer the following questions.')}
        </p>

        <fieldset className="satisfaction-survey__fieldset">
          <legend className="satisfaction-survey__legend">
            {t('1.Ease of use')}
          </legend>
          <CustomDropdown
            options={easeOptions}
            placeholder={t('Please select')}
            onSelect={handleEaseSelect}
            ariaLabel={t('Select ease of use')}
            className="satisfaction-survey__dropdown"
          />
        </fieldset>

        <fieldset className="satisfaction-survey__fieldset">
          <legend className="satisfaction-survey__legend">
            {t('2.Guide satisfaction')}
          </legend>
          <CustomDropdown
            options={satisfactionOptions}
            placeholder={t('Please select')}
            onSelect={handleSatisfactionSelect}
            ariaLabel={t('Select guide satisfaction')}
            className="satisfaction-survey__dropdown"
          />
        </fieldset>

        <button
          type="button"
          className="satisfaction-survey__button"
          onClick={handleSubmit}
        >
          {t('Next')}
        </button>
      </div>
    </div>
  );
}